import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from "react";

const getStyles = () => ({
    root: {
        width: "100%",
        height: "100%",
        padding: "1.875rem 1rem 0 1rem"
    },
    repeatDiv: {
        width: "100%", height: "2rem", mb: "1.5rem"
    },
    bottomDiv: {
        display: "flex", alignItems: "center", justifyContent: "space-between"
    },
    bottomLeftDiv: {
        width: "82%", height: "2rem"
    },
    bottomRightDiv: {
        width: "2rem", height: "2rem"
    }
});

const NavbarSkeleton = () => {
    const theme = useTheme();
    const styles = getStyles(theme);
    return <Box sx={styles.root}>
        <Box sx={{ width: "100%", height: "2.5rem", mb: "1.5rem" }}>
            <Skeleton variant="rounded" width="100%" height="100%" />
        </Box>
        {Array.from({ length: 12 }, (_, i) => (
            <Box key={i} sx={styles.repeatDiv}>
                <Skeleton variant="rounded" width="100%" height="100%" />
            </Box>
        ))}
        <Box sx={styles.bottomDiv}>
            <Box sx={styles.bottomLeftDiv}>
                <Skeleton variant="rounded" width="100%" height="100%" />
            </Box>
            <Box sx={styles.bottomRightDiv}>
                <Skeleton variant="circular" width="100%" height="100%" />
            </Box>
        </Box>
    </Box>
}

export default NavbarSkeleton;